import { render, staticRenderFns } from "./y-header.vue?vue&type=template&id=76f3c39e&"
import script from "./y-header.vue?vue&type=script&lang=js&"
export * from "./y-header.vue?vue&type=script&lang=js&"
import style0 from "./y-header.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports